import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';

export const ALU_GLAZY_LEAF_DOOR = 'aluglazyleafdoor';
export const ALU_GLAZY_ONLY_LEAF_DOOR = 'aluglazyonlyleafdoor';
export const ALU_GLAZY_ONLY_DOUBLE_LEAF_DOOR = 'aluglazyonlydoubleleafdoor';
export const SLIDY_DOOR_30 = 'slidydoor30';
export const SLIDY_DOOR_36 = 'slidydoor36';
export const SLIDY_ONLY_DOOR_36 = 'slidyonlydoor36';
export const SLIDY_DOUBLE_DOOR_30 = 'slidydoubledoor30';
export const SLIDY_DOUBLE_DOOR_36 = 'slidydoubledoor36';
export const SLIDY_ONLY_DOOR_30 = 'slidyonlydoor30';
export const SLIDY_ONLY_DOOR_OUTSIDE_30 = 'slidyonlydooroutside30';
export const SLIDY_ONLY_DOOR_OUTSIDE_GLASS_30 =
  'slidyonlydooroutsidesideglass30';
export const SLIDY_ONLY_DOOR_OUTSIDE_36 = 'slidyonlydooroutside36';
export const SLIDY_ONLY_DOOR_OUTSIDE_GLASS_36 =
  'slidyonlydooroutsidesideglass36';
export const ALU_GLAZY_LEAF_DOOR_GLASS_AROUND = 'aluglazyleafdoorglassaround';
export const ALU_GLAZY_DOUBLE_LEAF_DOOR = 'aluglazydoubleleafdoor';
export const ALU_GLAZY_DOUBLE_LEAF_DOOR_GLASS_AROUND =
  'aluglazydoubleleafdoorglassaround';
export const ALUMINIUM_LEAF_DOOR = 'aluminiumleafdoor';
export const ALUMINIUM_ONLY_LEAF_DOOR = 'aluminiumonlyleafdoor';
export const ALUMINIUM_LEAF_DOOR_GLASS_AROUND = 'aluminiumleafdoorglassaround';
export const ALUMINIUM_LEAF_DOOR_GLASS_ABOVE = 'aluminiumleafdoorglassabove';
export const ALUMINIUM_DOUBLE_LEAF_DOOR = 'aluminiumdoubleleafdoor';
export const ALUMINIUM_ONLY_DOUBLE_LEAF_DOOR = 'aluminiumonlydoubleleafdoor';
export const ALUMINIUM_DOUBLE_LEAF_DOOR_GLASS_AROUND =
  'aluminiumdoubleleafdoorglassaround';
export const ALUMINIUM_DOUBLE_LEAF_DOOR_GLASS_ABOVE =
  'aluminiumdoubleleafdoorglassabove';
export const ALUMINIUM_LEAF_DOOR_ELECTRICITY_BOX =
  'aluminiumleafdoorelectricitybox';
export const WOODY_BOX = 'woodybox';
export const WOODY_LEAF_DOOR_37 = 'woodyleafdoor37';
export const WOODY_LEAF_DOOR_37_GLASS_ABOVE = 'woodyleafdoor37glassabove';
export const WOODY_LEAF_DOOR_37_GLASS_AROUND = 'woodyleafdoor37glassaround';
export const WOODY_LEAF_DOOR_37_WOOD_ABOVE = 'woodyleafdoor37woodabove';
export const WOODY_LEAF_DOOR_37_GLASS = 'woodyleafdoor37glass';
export const WOODY_LEAF_DOOR_37_GLASS_GLASS_ABOVE =
  'woodyleafdoor37glassglassabove';
export const WOODY_LEAF_DOOR_37_GLASS_GLASS_AROUND =
  'woodyleafdoor37glassglassaround';
export const WOODY_LEAF_DOOR_37_GLASS_WOOD_ABOVE =
  'woodyleafdoor37glasswoodabove';
export const WOODY_LEAF_DOOR_37_UNREBATED_GLASS =
  'woodyleafdoor37unrebatedglass';
export const WOODY_LEAF_DOOR_37_UNREBATED_GLASS_GLASS_ABOVE =
  'woodyleafdoor37unrebatedglassglassabove';
export const WOODY_LEAF_DOOR_37_UNREBATED_GLASS_GLASS_AROUND =
  'woodyleafdoor37unrebatedglassglassaround';
export const WOODY_LEAF_DOOR_37_UNREBATED_GLASS_WOOD_ABOVE =
  'woodyleafdoor37unrebatedglasswoodabove';
export const WOODY_LEAF_DOOR_37_UNREBATED = 'woodyleafdoor37unrebated';
export const WOODY_LEAF_DOOR_37_UNREBATED_GLASS_ABOVE =
  'woodyleafdoor37unrebatedglassabove';
export const WOODY_LEAF_DOOR_37_UNREBATED_GLASS_AROUND =
  'woodyleafdoor37unrebatedglassaround';
export const WOODY_LEAF_DOOR_37_UNREBATED_WOOD_ABOVE =
  'woodyleafdoor37unrebatedwoodabove';
export const WOODY_LEAF_DOOR_40 = 'woodyleafdoor40';
export const WOODY_LEAF_DOOR_40_GLASS_ABOVE = 'woodyleafdoor40glassabove';
export const WOODY_LEAF_DOOR_40_GLASS_AROUND = 'woodyleafdoor40glassaround';
export const WOODY_LEAF_DOOR_40_WOOD_ABOVE = 'woodyleafdoor40woodabove';
export const WOODY_LEAF_DOOR_40_GLASS = 'woodyleafdoor40glass';
export const WOODY_LEAF_DOOR_40_GLASS_GLASS_ABOVE =
  'woodyleafdoor40glassglassabove';
export const WOODY_LEAF_DOOR_40_GLASS_GLASS_AROUND =
  'woodyleafdoor40glassglassaround';
export const WOODY_LEAF_DOOR_40_GLASS_WOOD_ABOVE =
  'woodyleafdoor40glasswoodabove';
export const WOODY_LEAF_DOOR_40_PORTAL_OUT = 'woodyleafdoor40portalout';
export const WOODY_LEAF_DOOR_40_PORTAL_IN = 'woodyleafdoor40portalin';
export const WOODY_LEAF_DOOR_40_L_FRAME_GLASS = 'woodyleafdoor40lframeglass';
export const WOODY_LEAF_DOOR_40_L_FRAME_GLASS_GLASS_ABOVE =
  'woodyleafdoor40lframeglassglassabove';
export const WOODY_LEAF_DOOR_40_L_FRAME_GLASS_GLASS_AROUND =
  'woodyleafdoor40lframeglassglassaround';
export const WOODY_LEAF_DOOR_40_L_FRAME_GLASS_WOOD_ABOVE =
  'woodyleafdoor40lframeglasswoodabove';
export const WOODY_LEAF_DOOR_40_L_FRAME = 'woodyleafdoor40lframe';
export const WOODY_LEAF_DOOR_40_L_FRAME_GLASS_ABOVE =
  'woodyleafdoor40lframeglassabove';
export const WOODY_LEAF_DOOR_40_L_FRAME_GLASS_AROUND =
  'woodyleafdoor40lframeglassaround';
export const WOODY_LEAF_DOOR_40_L_FRAME_WOOD_ABOVE =
  'woodyleafdoor40lframewoodabove';
export const WOODY_LEAF_DOOR_PLANE_40 = 'woodyleafdoorplane40';
export const WOODY_LEAF_DOOR_PLANE_40_GLASS_ABOVE =
  'woodyleafdoorplane40glassabove';
export const WOODY_LEAF_DOOR_PLANE_WOOD_DOOR = 'woodyleafdoorplanewooddoor';
export const WOODY_LEAF_DOOR_PLANE_WOOD_DOOR_GLASS_ABOVE =
  'woodyleafdoorplanewooddoorglassabove';
export const WOODY_LEAF_DOOR_42_GLASS = 'woodyleafdoor42glass';
export const WOODY_LEAF_DOOR_42_GLASS_GLASS_ABOVE =
  'woodyleafdoor42glassglassabove';
export const WOODY_LEAF_DOOR_42_GLASS_GLASS_AROUND =
  'woodyleafdoor42glassglassaround';
export const WOODY_LEAF_DOOR_42_GLASS_WOOD_ABOVE =
  'woodyleafdoor42glasswoodabove';
export const WOODY_LEAF_DOOR_42 = 'woodyleafdoor42';
export const WOODY_LEAF_DOOR_42_GLASS_ABOVE = 'woodyleafdoor42glassabove';
export const WOODY_LEAF_DOOR_42_GLASS_AROUND = 'woodyleafdoor42glassaround';
export const WOODY_LEAF_DOOR_42_WOOD_ABOVE = 'woodyleafdoor42woodabove';
export const WOODY_DOUBLE_LEAF_DOOR_42_GLASS = 'woodydoubleleafdoor42glass';
export const WOODY_DOUBLE_LEAF_DOOR_42_GLASS_GLASS_ABOVE =
  'woodydoubleleafdoor42glassglassabove';
export const WOODY_DOUBLE_LEAF_DOOR_42_GLASS_GLASS_AROUND =
  'woodydoubleleafdoor42glassglassaround';
export const WOODY_DOUBLE_LEAF_DOOR_42_GLASS_WOOD_ABOVE =
  'woodydoubleleafdoor42glasswoodabove';
export const WOODY_DOUBLE_LEAF_DOOR_42 = 'woodydoubleleafdoor42';
export const WOODY_DOUBLE_LEAF_DOOR_42_GLASS_ABOVE =
  'woodydoubleleafdoor42glassabove';
export const WOODY_DOUBLE_LEAF_DOOR_42_GLASS_AROUND =
  'woodydoubleleafdoor42glassaround';
export const WOODY_DOUBLE_LEAF_DOOR_42_WOOD_ABOVE =
  'woodydoubleleafdoor42woodabove';
export const WOODY_LEAF_DOOR_43 = 'woodyleafdoor43';
export const WOODY_LEAF_DOOR_43_GLASS_ABOVE = 'woodyleafdoor43glassabove';
export const WOODY_LEAF_DOOR_43_GLASS_AROUND = 'woodyleafdoor43glassaround';
export const WOODY_LEAF_DOOR_43_WOOD_ABOVE = 'woodyleafdoor43woodabove';
export const NO_DOOR = 'nodoor';
export const NO_DOOR_GLASS_AROUND = 'nodoorglassaround';

export const slidyDoorTypes = [
  SLIDY_DOOR_30,
  SLIDY_DOUBLE_DOOR_30,
  SLIDY_DOOR_36,
  SLIDY_ONLY_DOOR_36,
  SLIDY_DOUBLE_DOOR_36,
  SLIDY_ONLY_DOOR_30,
  SLIDY_ONLY_DOOR_OUTSIDE_30,
  SLIDY_ONLY_DOOR_OUTSIDE_GLASS_30,
  SLIDY_ONLY_DOOR_OUTSIDE_36,
  SLIDY_ONLY_DOOR_OUTSIDE_GLASS_36,
];

export const isSlidyDoor = (door: IGlassWallDoor): boolean =>
  slidyDoorTypes.includes(door.typeName);

export const isOnlyDoorType = (door: IGlassWallDoor): boolean =>
  door.typeName.toLowerCase().includes('onlydoor');

export const isWoodyDoubleDoor = (door: IGlassWallDoor) => {
  return (
    door.typeName.toLowerCase().includes('double') &&
    door.typeName.toLowerCase().includes('woody')
  );
};

export const isAluDoubleDoor = (door: IGlassWallDoor) => {
  return (
    door.typeName.toLowerCase().includes('double') &&
    door.typeName.toLowerCase().includes('alu')
  );
};

export const isWoodyTypeDoor = (door: IGlassWallDoor) => {
  return door.typeName.includes('woody');
};

export const isAluTypeDoor = (door: IGlassWallDoor) => {
  return door.typeName.includes('alu');
};

export const is2kTypeDoor = (door: IGlassWallDoor) => {
  return door.typeName.includes('2K');
};

export const isWoodyBox = (door: IGlassWallDoor) => {
  return door.typeName.includes('woodybox');
};

export const isAluGlazyLeafDoorGlassAround = (door: IGlassWallDoor) => {
  return (
    door.typeName === ALU_GLAZY_DOUBLE_LEAF_DOOR_GLASS_AROUND ||
    door.typeName === ALU_GLAZY_LEAF_DOOR_GLASS_AROUND
  );
};

export const isAluLeafDoorGlassAbove = (door: IGlassWallDoor) => {
  return (
    door.typeName === ALUMINIUM_DOUBLE_LEAF_DOOR_GLASS_ABOVE ||
    door.typeName === ALUMINIUM_LEAF_DOOR_GLASS_ABOVE
  );
};
export const isAluDoorElectricityBox = (door: IGlassWallDoor) => {
  return door.typeName === ALUMINIUM_LEAF_DOOR_ELECTRICITY_BOX;
};

export const isAluGlazyOnlyLeafDoor = (door: IGlassWallDoor) => {
  return (
    door.typeName === ALU_GLAZY_ONLY_LEAF_DOOR ||
    door.typeName === ALU_GLAZY_ONLY_DOUBLE_LEAF_DOOR
  );
};

export const isAluGlazyDoor = (door: IGlassWallDoor) => {
  return (
    door.typeName === ALU_GLAZY_LEAF_DOOR ||
    door.typeName === ALU_GLAZY_ONLY_LEAF_DOOR ||
    door.typeName === ALU_GLAZY_ONLY_DOUBLE_LEAF_DOOR ||
    door.typeName === ALU_GLAZY_LEAF_DOOR_GLASS_AROUND ||
    door.typeName === ALU_GLAZY_DOUBLE_LEAF_DOOR ||
    door.typeName === ALU_GLAZY_DOUBLE_LEAF_DOOR_GLASS_AROUND
  );
};

const doorTypes = [
  SLIDY_DOOR_30,
  SLIDY_DOUBLE_DOOR_30,
  SLIDY_DOOR_36,
  SLIDY_ONLY_DOOR_36,
  SLIDY_DOUBLE_DOOR_36,
  ALU_GLAZY_LEAF_DOOR,
  ALU_GLAZY_ONLY_LEAF_DOOR,
  ALU_GLAZY_ONLY_DOUBLE_LEAF_DOOR,
  SLIDY_ONLY_DOOR_30,
  SLIDY_ONLY_DOOR_OUTSIDE_30,
  SLIDY_ONLY_DOOR_OUTSIDE_GLASS_30,
  SLIDY_ONLY_DOOR_OUTSIDE_36,
  SLIDY_ONLY_DOOR_OUTSIDE_GLASS_36,
  ALU_GLAZY_LEAF_DOOR_GLASS_AROUND,
  ALU_GLAZY_DOUBLE_LEAF_DOOR,
  ALU_GLAZY_DOUBLE_LEAF_DOOR_GLASS_AROUND,
  ALUMINIUM_LEAF_DOOR,
  ALUMINIUM_ONLY_LEAF_DOOR,
  ALUMINIUM_LEAF_DOOR_GLASS_AROUND,
  ALUMINIUM_LEAF_DOOR_GLASS_ABOVE,
  ALUMINIUM_DOUBLE_LEAF_DOOR,
  ALUMINIUM_ONLY_DOUBLE_LEAF_DOOR,
  ALUMINIUM_DOUBLE_LEAF_DOOR_GLASS_AROUND,
  ALUMINIUM_DOUBLE_LEAF_DOOR_GLASS_ABOVE,
  ALUMINIUM_LEAF_DOOR_ELECTRICITY_BOX,
  WOODY_BOX,
  WOODY_LEAF_DOOR_37,
  WOODY_LEAF_DOOR_37_GLASS_ABOVE,
  WOODY_LEAF_DOOR_37_GLASS_AROUND,
  WOODY_LEAF_DOOR_37_WOOD_ABOVE,
  WOODY_LEAF_DOOR_37_GLASS,
  WOODY_LEAF_DOOR_37_GLASS_GLASS_ABOVE,
  WOODY_LEAF_DOOR_37_GLASS_GLASS_AROUND,
  WOODY_LEAF_DOOR_37_GLASS_WOOD_ABOVE,
  WOODY_LEAF_DOOR_37_UNREBATED_GLASS,
  WOODY_LEAF_DOOR_37_UNREBATED_GLASS_GLASS_ABOVE,
  WOODY_LEAF_DOOR_37_UNREBATED_GLASS_GLASS_AROUND,
  WOODY_LEAF_DOOR_37_UNREBATED_GLASS_WOOD_ABOVE,
  WOODY_LEAF_DOOR_37_UNREBATED,
  WOODY_LEAF_DOOR_37_UNREBATED_GLASS_ABOVE,
  WOODY_LEAF_DOOR_37_UNREBATED_GLASS_AROUND,
  WOODY_LEAF_DOOR_37_UNREBATED_WOOD_ABOVE,
  WOODY_LEAF_DOOR_40,
  WOODY_LEAF_DOOR_40_GLASS_ABOVE,
  WOODY_LEAF_DOOR_40_GLASS_AROUND,
  WOODY_LEAF_DOOR_40_WOOD_ABOVE,
  WOODY_LEAF_DOOR_40_GLASS,
  WOODY_LEAF_DOOR_40_GLASS_GLASS_ABOVE,
  WOODY_LEAF_DOOR_40_GLASS_GLASS_AROUND,
  WOODY_LEAF_DOOR_40_GLASS_WOOD_ABOVE,
  WOODY_LEAF_DOOR_40_PORTAL_OUT,
  WOODY_LEAF_DOOR_40_PORTAL_IN,
  WOODY_LEAF_DOOR_40_L_FRAME_GLASS,
  WOODY_LEAF_DOOR_40_L_FRAME_GLASS_GLASS_ABOVE,
  WOODY_LEAF_DOOR_40_L_FRAME_GLASS_GLASS_AROUND,
  WOODY_LEAF_DOOR_40_L_FRAME_GLASS_WOOD_ABOVE,
  WOODY_LEAF_DOOR_40_L_FRAME,
  WOODY_LEAF_DOOR_40_L_FRAME_GLASS_ABOVE,
  WOODY_LEAF_DOOR_40_L_FRAME_GLASS_AROUND,
  WOODY_LEAF_DOOR_40_L_FRAME_WOOD_ABOVE,
  WOODY_LEAF_DOOR_PLANE_40,
  WOODY_LEAF_DOOR_PLANE_40_GLASS_ABOVE,
  WOODY_LEAF_DOOR_PLANE_WOOD_DOOR,
  WOODY_LEAF_DOOR_PLANE_WOOD_DOOR_GLASS_ABOVE,
  WOODY_LEAF_DOOR_42_GLASS,
  WOODY_LEAF_DOOR_42_GLASS_GLASS_ABOVE,
  WOODY_LEAF_DOOR_42_GLASS_GLASS_AROUND,
  WOODY_LEAF_DOOR_42_GLASS_WOOD_ABOVE,
  WOODY_LEAF_DOOR_42,
  WOODY_LEAF_DOOR_42_GLASS_ABOVE,
  WOODY_LEAF_DOOR_42_GLASS_AROUND,
  WOODY_LEAF_DOOR_42_WOOD_ABOVE,
  WOODY_DOUBLE_LEAF_DOOR_42_GLASS,
  WOODY_DOUBLE_LEAF_DOOR_42_GLASS_GLASS_ABOVE,
  WOODY_DOUBLE_LEAF_DOOR_42_GLASS_GLASS_AROUND,
  WOODY_DOUBLE_LEAF_DOOR_42_GLASS_WOOD_ABOVE,
  WOODY_DOUBLE_LEAF_DOOR_42,
  WOODY_DOUBLE_LEAF_DOOR_42_GLASS_ABOVE,
  WOODY_DOUBLE_LEAF_DOOR_42_GLASS_AROUND,
  WOODY_DOUBLE_LEAF_DOOR_42_WOOD_ABOVE,
  WOODY_LEAF_DOOR_43,
  WOODY_LEAF_DOOR_43_GLASS_ABOVE,
  WOODY_LEAF_DOOR_43_GLASS_AROUND,
  WOODY_LEAF_DOOR_43_WOOD_ABOVE,
  NO_DOOR,
  NO_DOOR_GLASS_AROUND,
];

export default doorTypes;
